import { combineReducers } from '@reduxjs/toolkit';

import { changePasswordReducer } from 'theSource/features/ChangePassword/services';
import { snackbarReducer } from 'theSource/components/Snackbar/services';
import { authenticationReducer } from 'theSource/features/Login/services';
import { termsOfUseReducer } from 'theSource/features/TermsOfUse/services';
import { pageNotFoundReducer } from 'theSource/components/PageNotFound/services';
import { nativeAuthReducer } from 'theSource/services/nativeAuth';
import { forgotPasswordReducer } from 'theSource/features/ForgotPassword/services';
import { downloadPromptReducer } from 'theSource/features/PostLoginDownloadPrompt/services';
import { navigationDisplayReducer } from 'theSource/services/navigationDisplay';
import { feedMessagesReducer } from 'theSource/features/Inbox/services';
import { adminRedirectReducer } from 'theSource/features/AccessDenied/services';
import { enrollmentReducer } from '../../enrollment/app/rootReducer';
import { enrollmentApiErrorDisplayReducer } from 'theSource/services';
import { DisplayPostElectionReducer } from 'enrollment/services';

export const theSourceReducer = combineReducers({
  snackbar: snackbarReducer,
  authentication: authenticationReducer,
  termsOfUse: termsOfUseReducer,
  pageNotFound: pageNotFoundReducer,
  nativeAuth: nativeAuthReducer,
  changePassword: changePasswordReducer,
  forgotPassword: forgotPasswordReducer,
  downloadPrompt: downloadPromptReducer,
  navigationDisplay: navigationDisplayReducer,
  feedMessages: feedMessagesReducer,
  adminRedirect: adminRedirectReducer,
  enrollmentApiErrorReducer: enrollmentApiErrorDisplayReducer,
});

export const rootReducer = combineReducers({
  theSource: theSourceReducer,
  enrollment: enrollmentReducer,
  postElectToast: DisplayPostElectionReducer,
});
